<div class="container">
    <div mat-dialog-content>
      <h1 class="heading">Confirmation</h1>
       <p>{{ data.confirmationText }}</p>
    </div>
      <div class="buttons">
        <button mat-button class="yes-button" (click)="onYesClick()">Yes</button>
        <button mat-button class="no-button" (click)="onNoClick()">No</button>
      </div>
</div>
